import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleAccessorySunglasses = customSolarIconWrapper(<g transform="translate(80.5 112.5)">
	<rect x="41" y="4.26538" width="35" height="20" rx="9" transform="rotate(-7 41 4.26538)" fill="#202020" />
	<rect y="10.2654" width="35" height="20" rx="9" transform="rotate(-7 0 10.2654)" fill="#202020" />
	<rect x="31.8193" y="12.2909" width="15.1619" height="7.14516" rx="3.5" transform="rotate(-5 31.8193 12.2909)" fill="#202020" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleAccessorySunglasses;
